import { render, staticRenderFns } from "./PieChartCard.vue?vue&type=template&id=242c2680&scoped=true&"
import script from "./PieChartCard.vue?vue&type=script&lang=js&"
export * from "./PieChartCard.vue?vue&type=script&lang=js&"
import style0 from "./PieChartCard.vue?vue&type=style&index=0&id=242c2680&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "242c2680",
  null
  
)

export default component.exports